import { Component, OnInit } from '@angular/core';
import { MailValidatorService } from 'src/app/shared/services/mail-validator.service';
import { Tutor } from '../../models/tutor.model';
import { TutorService } from '../../services/tutor.service';

@Component({
    selector: 'app-tutor-new',
    templateUrl: './tutor-new.component.html',
    styleUrls: [ './tutor-new.component.scss' ]
})
export class TutorNewComponent implements OnInit {

    public tutor: Tutor = new Tutor();

    public tutorEmailConfirmation: string;
    public tutorPasswordConfirmation: string;

    public isValidEmail: boolean;
    public isValidEmailConfirmation: boolean;
    public emailValidationError: string;
    public emailConfirmationValidationError: string;

    public isValidPassword: boolean;
    public isValidPasswordConfirmation: boolean;
    public passwordValidationError: string;
    public passwordConfirmationValidationError: string;

    public isProcessing: boolean = false;
    public showSuccessAlert: boolean = false;
    public successMessage: string = 'El usuario se ha creado correctamente.';
    public showErrorAlert: boolean = false;
    public errorMessage: string;

    constructor(private tutorService: TutorService, private mailValidatorService: MailValidatorService) { }

    ngOnInit() { }

    public onEmailChange() {

        if (this.tutor.mail === null && this.tutor.mail === "") {
            this.tutor.mail          = null;
            this.isValidEmail         = false;
            this.emailValidationError = null;
            return;
        }

        let emailValidation       = this.mailValidatorService.validate(this.tutor.mail);
        this.isValidEmail         = emailValidation.success;
        this.emailValidationError = this.isValidEmail ? null : emailValidation.message;

    }

    public onEmailConfirmationChange() {

        if (this.tutorEmailConfirmation === null && this.tutorEmailConfirmation === "") {
            this.tutorEmailConfirmation = null;
            this.isValidEmailConfirmation           = false;
            this.emailConfirmationValidationError   = null;
            return;
        }

        let emailValidation                   = this.mailValidatorService.validate(this.tutorEmailConfirmation);
        this.isValidEmailConfirmation         = emailValidation.success;
        this.emailConfirmationValidationError = this.isValidEmailConfirmation ? null : emailValidation.message;

        if (this.tutor.mail !== this.tutorEmailConfirmation) {

            this.isValidEmailConfirmation = false;
            this.emailConfirmationValidationError = 'Las direcciones de correo no coinciden';

        }

    }

    public onPasswordChange() {

        this.isValidPassword         = true;
        this.passwordValidationError = null;

        if (this.tutor.password.length < 6) {

            this.isValidPassword = false;
            this.passwordValidationError = 'La contraseña no puede tener menos de 6 caracteres';

        }

    }

    public onPasswordConfirmationChange() {

        this.isValidPasswordConfirmation         = true;
        this.passwordConfirmationValidationError = null;

        if (this.tutor.password !== this.tutorPasswordConfirmation) {

            this.isValidPasswordConfirmation = false;
            this.passwordConfirmationValidationError = 'Las contraseñas no coinciden';

        }

    }

    public isFormValid() : boolean {

        let isValidDni                  = this.tutor.dni && this.tutor.dni !== null && this.tutor.dni !== '';
        let isValidName                 = this.tutor.name && this.tutor.name !== null && this.tutor.name !== '';
        let isValidSurname              = this.tutor.surname && this.tutor.surname !== null && this.tutor.surname !== '';
        let isValidEmail                = this.tutor.mail && this.tutor.mail !== null && this.tutor.mail !== '' && this.isValidEmail;
        let isValidEmailConfirmation    = this.tutorEmailConfirmation && this.tutorEmailConfirmation !== null && this.tutorEmailConfirmation !== '' && this.isValidEmailConfirmation;
        let isValidPassword             = this.tutor.password && this.tutor.password !== null && this.tutor.password !== '' && this.isValidPassword;
        let isValidPasswordConfirmation = this.tutorPasswordConfirmation && this.tutorPasswordConfirmation !== null && this.tutorPasswordConfirmation !== '' && this.isValidPasswordConfirmation;
        let isValidPhone1               = this.tutor.phone1 && this.tutor.phone1 !== null && this.tutor.phone1 !== ''

        return isValidDni && isValidName && isValidSurname &&
               isValidEmail && isValidEmailConfirmation &&
               isValidPassword && isValidPasswordConfirmation &&
               isValidPhone1;

    }

    public postTutor() {

        this.isProcessing = true;

        this.tutorService.create(this.tutor).subscribe({

            next: () => {
                this.showSuccessAlertMessage(5000);
                this.resetForm();
            },

            error: (error: string) => {
                this.errorMessage = error;
            }

        })
        .add(() => {
            this.isProcessing = false;
        });

    }

    private resetForm() {

        this.tutor = new Tutor();
        this.tutorEmailConfirmation = null;
        this.tutorPasswordConfirmation = null;

    }

    private showSuccessAlertMessage(miliseconds: number) {

        this.showSuccessAlert = true;
        setTimeout(() => {
            this.showSuccessAlert = false;
        }, miliseconds);

    }

}
